import React from 'react'
import {ReactComponent as ProfileIcon} from 'images/icons/profil.svg'

export const ProfileMenu = (props) => {
  return (
    <ProfileIcon className={`fill-current ${props.className?props.className:''}`}/>
  )
}
